'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidElement = undefined;

var _invariant = require('fbjs/lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _ReactElement = require('react/lib/ReactElement');

var _ReactElement2 = _interopRequireDefault(_ReactElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValidElement = exports.isValidElement = function isValidElement(nextElement) {
  return (0, _invariant2.default)(_ReactElement2.default.isValidElement(nextElement), 'ReactKonsul.render(): Invalid component element.%s', typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate it by passing it to React.createElement.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent copies of React.' : '');
};


//////////////////
// WEBPACK FOOTER
// ../lib-react/lib/utils/invariants.js
// module id = 684
// module chunks = 0